export const PROJECT_CATEGORY = {
  ads: 'ads',
  landingPage: 'landing_page',
  websitePersonalization: 'website_personalization',
  productDescription: 'product_description',
  productListing: 'product_listing',
  social: 'social',
  blog: 'blog',
  email: 'email',
  sms: 'sms',
  canvas: 'canvas',
} as const;
export type ProjectCategory = (typeof PROJECT_CATEGORY)[keyof typeof PROJECT_CATEGORY];

export const DEPRECATED_PROJECT_TYPE = {
  blogPost: 'blog_post',
  productDescription: 'product_description',
  featuresToBenefits: 'features_to_benefits',
  seoMetaDescription: 'seo_meta_description',
  landingPageBuilder: 'landing_page_builder',
  canvas: 'canvas',
  facebookAd: 'facebook_ad',
  googleAd: 'google_ad',
  taboolaAd: 'taboola_ad',
  outbrainAd: 'outbrain_ad',
  linkedinAd: 'linkedin_ad',
  twitterAd: 'twitter_ad',
  pinterestAd: 'pinterest_ad',
  teadsSingleImage: 'teads_single_image',
  teadsSingleVideo: 'teads_single_video',
  teadsCarousel: 'teads_carousel',
  teadsSocialLayout1: 'teads_social_layout_1',
  teadsSocialLayout2: 'teads_social_layout_2',
  amazonProductDescription: 'amazon_product_description',
  walmartProductListing: 'walmart_product_listing',
  facebookSocial: 'facebook_social',
  instagramSocial: 'instagram_social',
  twitterSocial: 'twitter_social',
  linkedinSocial: 'linkedin_social',
  pinterestSocial: 'pinterest_social',
  youtubeSocial: 'youtube_social',
  emailSubjectLine: 'email_subject_line',
  emailPromotional: 'email_promotional',
  emailColdOutreach: 'email_cold_outreach',
  sms: 'sms',
  shopifyLandingPage: 'shopify_landing_page',
  shopifyProduct: 'shopify_product',
  shopifyProductsDescription: 'shopify_products_description',
} as const;
export type DeprecatedProjectType =
  (typeof DEPRECATED_PROJECT_TYPE)[keyof typeof DEPRECATED_PROJECT_TYPE];

export const ACTIVE_PROJECT_TYPE = {
  document: 'document_editor',
  blogPostBuilder: 'blog_post_builder',
  continuousOptimization: 'product_landing_page_url',
  wtmHomePage: 'wtm_home_page',
  longFormBuilder: 'long_form_builder',
} as const;
export type ActiveProjectType = (typeof ACTIVE_PROJECT_TYPE)[keyof typeof ACTIVE_PROJECT_TYPE];

/**
 * Project type
 */
export const PROJECT_TYPE = {
  ...ACTIVE_PROJECT_TYPE,
  ...DEPRECATED_PROJECT_TYPE,
} as const;
export type ProjectType = (typeof PROJECT_TYPE)[keyof typeof PROJECT_TYPE];

// Project types that are displayed on the main Projects page
export const GENERAL_PROJECT_TYPES = [
  PROJECT_TYPE.document,
  PROJECT_TYPE.blogPostBuilder,
  PROJECT_TYPE.longFormBuilder,
];

export const PROJECT_STATUS = {
  created: 'created',
  submitted: 'submitted',
  done: 'done',
  doneWithErrors: 'done_with_errors',
  briefApprovalWaits: 'brief_waits_ac_content',
  briefProcessingError: 'brief_processing_error',
  blogDraft: 'blog_draft',
  blogEditing: 'blog_editing',
  blogPostArchived: 'blog_post_archived',
  longFormDraft: 'long_form_draft',
  longFormEditing: 'long_form_editing',
  longFormArchived: 'long_form_archived',
  legacy: 'legacy',
} as const;
export type ProjectStatus = (typeof PROJECT_STATUS)[keyof typeof PROJECT_STATUS];

export const PROJECT_READONLY_HINT = 'This project is now view-only';

export const BAREBONE_PROJECT_ID = 'barebone_project';

export const ACCESS_STATE_TYPE = {
  read_only: 'read_only',
  read_write: 'read_write',
};
export type AccessStateType = (typeof ACCESS_STATE_TYPE)[keyof typeof ACCESS_STATE_TYPE];

export const DEFAULT_DOCUMENT_NAME = 'Untitled project';

export const DEFAULT_BLOG_NAME = 'Untitled blog project';

export const SUGGESTED_PROJECT_NAME_LENGTH_LIMIT = 83;

export const PROJECTS_FILTER = {
  currentUser: 'currentUser',
  allProjects: 'allProjects',
};
export type ProjectsFilter = (typeof PROJECTS_FILTER)[keyof typeof PROJECTS_FILTER];

export const ERROR_LOADING =
  'Your projects can’t be fetched due to a temporary issue. Please try again later.';
export const ACTIONS_LOCATION = {
  blog: 'blog',
  document: 'document',
};

export const CAPITALIZATION_LABEL = 'Capitalization';

export const EDITOR_TYPE = {
  longForm: 'long_form',
  shortForm: 'short_form',
};
export type EditorType = (typeof EDITOR_TYPE)[keyof typeof EDITOR_TYPE];

export const EDITOR_LABEL_MAP = {
  [EDITOR_TYPE.shortForm]: 'Short form',
  [EDITOR_TYPE.longForm]: 'Long form',
};

export const isLongFormEditorType = (editorType: EditorType): boolean => {
  return editorType === EDITOR_TYPE.longForm;
};

export const isShortFormEditorType = (editorType: EditorType): boolean => {
  return editorType === EDITOR_TYPE.shortForm;
};

export const CLASSIFIED_TEMPLATE_BLOG = 'blog';
export type ClassifiedTemplateBlog = typeof CLASSIFIED_TEMPLATE_BLOG;
